export default __webpack_public_path__ + "static/media/videoIcon.61278777.svg";